<template>
  <div class="container">
    <!-- 新增检测类别 -->
    <a-modal class="" title="新增检测类别" :visible="categoryVisible" @cancel="closeVisible" width="60%" @ok="submit">
      <div class="title">
        <span>行业类别</span>
      </div>
      <div class="containerTop">
        <a-form-model :model="categoryList" ref="categoryListRef" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-row>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="所属行业"
                prop="industryId"
                :rules="{
                  required: true,
                  message: '请选择所属行业',
                  trigger: 'change',
                }"
              >
                <!-- <span>{{ categoryList.categoryName}}</span> -->
                <a-select
                  allowClear
                  placeholder="请选择所属行业"
                  v-model="categoryList.industryId"
                  @change="getCategory"
                  style="width: 100%"
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option :value="item.id" v-for="(item, index) in dataList" :key="index">
                    {{ item.industryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="类别名称"
                prop="pollutantName"
                :rules="{
                  required: true,
                  message: '请填写类别名称',
                  trigger: 'change',
                }"
              >
                <a-input v-model="categoryList.pollutantName" @change="getCategory"></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12" class="bottom">
              <a-form-model-item
                :label-col="{ span: 6 }"
                class="model_span_form"
                :wrapper-col="{ span: 18 }"
                label="涉及检测性质"
                prop="quoteTestNatureList"
                :rules="{
                  required: true,
                  message: '请选择涉及检测性质',
                  trigger: 'change',
                }"
              >
                <a-checkbox-group
                  v-model="categoryList.quoteTestNatureList"
                  :options="checkout"
                  @change="checkoutChange"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="title">
        <span>检测物质</span>
      </div>
      <div class="containerTop">
        <AddMatter
          :selectedRowKeys="selectedRowKeys"
          :selecteVal="selecteVal"
          :examineList="examineList"
          @changeData="getList"
          :pagination="pagination"
          @changeList="changeList"
          @getVal="getVal"
        ></AddMatter>
      </div>
    </a-modal>
  </div>
</template>

<script>
import AddMatter from './addMatter.vue'
import { industryInfo, baseFactor, getNatureList } from '@/api/Industry'
import { addPollutantType } from '@/api/surrounding'
export default {
  components: {
    AddMatter,
  },
  props: ['categoryVisible'],
  data() {
    return {
      checkoutData: [],
      checkout: ['发证、复证', '一般委托', '监督检测'],
      categoryList: {
        pollutantName: '',
        industryName: '',
        industryId: undefined,
        quoteTestNatureList: undefined,
      },
      data: {
        factorName: '',
        subcategoryId: '',
      },
      examineList: [],
      // selectedRowKeys: '',
      dataList: [],
      pagination: {
        //分页数据
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        current: 1,
        pageSize: 10,
        totalCount: 0,
      },
      ids: [],
      selectedRowKeys: {
        1: [],
      },
      selecteVal: [],
    }
  },
  created() {
    
  },
  methods: {
    checkoutChange(e) {
      console.log(e, 'eeeeeeeeeeeeeeeeeeeee')
    },
    init() {
      this.getList()
      this.getData()
      // 查询行业信息列表
      industryInfo({
        projectId: 4,
      }).then((res) => {
        if (res.code == 200) {
          this.dataList = res.data
          console.log(this.dataList, 'this.dataList =========================')
        }
      })
    },
    getData() {
      getNatureList().then((res) => {
        if (res.code == 200) {
          this.checkoutData = res.data.list
        }
      })
    },
    getVal(data) {
      this.ids = []
      // val.forEach(item => {
      //     this.ids.push(item.id)
      // })
      var obj = data
      // var ids = []
      for (let i in obj) {
        obj[i].forEach((item) => {
          this.ids.push(item.id)
        })
      }
    },
    changeList(data) {
      this.data = data
      console.log(data, 'searchData==============')
      this.getList()
    },
    getList(data) {
      if (data) {
        this.pagination.current = data.current
        this.pagination.pageSize = data.pageSize
      }
      // tiis.$emit('changeData',data)
      baseFactor({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        categoryId: 1000,
        subcategoryId: this.data.subcategoryId,
        factorName: this.data.factorName,
      }).then((res) => {
        if (res.code == 200) {
          this.examineList = res.data
          this.pagination.totalCount = res.total
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getCategory() {
      // this.$emit('getCategoryData',this.categoryList)
      this.getList()
    },
    //查询下拉列表
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 多选事件

    // 弹窗关闭事件
    closeVisible() {
      this.$refs.categoryListRef.resetFields()
      this.categoryList.industryId = undefined
      this.categoryList.pollutantName = ''
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.getList()
      this.categoryVisible = false
      this.$emit('changeCategoryVisible', this.categoryVisible)
    },
    // 弹窗提交事件
    submit() {
        var data = []
        console.log( this.checkoutList, ' this.checkoutList')
      this.checkoutData.forEach((item) => {
        this.categoryList.quoteTestNatureList.forEach((item1) => {
          if (item.natureName == item1) {
            data.push(item)
          }
        })
      })
       this.categoryList.quoteTestNatureList = data
      this.$refs.categoryListRef.validate((valid) => {
        if (valid) {
          addPollutantType({
            projectId: 4,
            pollutantName: this.categoryList.pollutantName,
            industryId: this.categoryList.industryId,
            quoteTestNatureList: this.categoryList.quoteTestNatureList,
            ids: this.ids,
          }).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.$emit('refreshPollutant')
              this.categoryVisible = false
              this.categoryList = {}
              this.selectedRowKeys = { 1: [] }
              this.selecteVal = []
              this.pagination.current = 1
              this.pagination.pageSize = 10
              this.$emit('changeCategoryVisible', this.categoryVisible)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style >
.bottom {
  margin-top: 20px;
}
.title {
  margin: 10px;
  padding: 5px;
}
.containerTop {
  background-color: #fff;
  margin: 10px;
  padding: 5px;
  border-radius: 15px;
}
</style>